"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVENTORY_ROLES = void 0;
var INVENTORY_ROLES;
(function (INVENTORY_ROLES) {
    INVENTORY_ROLES["SEARCH_INVENTORY"] = "search-inventory";
    INVENTORY_ROLES["VIEW_INVENTORY"] = "view-inventory";
    INVENTORY_ROLES["VIEW_SUPPLY_AND_DEMAND"] = "view-supply-and-demand";
    INVENTORY_ROLES["ADJUST_INVENTORY"] = "adjust-inventory";
    INVENTORY_ROLES["REVIEW_INVENTORY"] = "review-inventory";
    INVENTORY_ROLES["RUN_ALLOCATION"] = "run-allocation";
})(INVENTORY_ROLES = exports.INVENTORY_ROLES || (exports.INVENTORY_ROLES = {}));
//# sourceMappingURL=inventory.roles.js.map